define([
	"csi/canvas/storeFactory",
	"csi/xml"
], function(storeFactory,xml) {

	var AVAILABLE = "AvailableToSell";
	var DRAFT = "Draft";
	var MARKETING_COLLECTION = "MarketingCollection";
	var MARKETING_LOOK = "MarketingLook";
	var MARKETING_SEGMENT = "MarketingSegment";
	var MC_MATERIAL = "MCMaterial";
	var MC_PRODUCT = "MCProduct";
	var NOT_AVAILABLE = "NotAvailable";
	var REL_TO_CUST = "ReleaseToCustomers";
	var REL_TO_MARKET = "ReleaseToMarkets";
	var SOLD_OUT = "SoldOut";

	storeFactory.add(MARKETING_COLLECTION, MARKETING_LOOK, "Parent:PrimaryCollection");
	storeFactory.add(MARKETING_COLLECTION, MC_MATERIAL, "Child:Materials");
	storeFactory.add(MARKETING_COLLECTION, MC_PRODUCT, "Child:Products");
	storeFactory.add(MARKETING_COLLECTION, MARKETING_SEGMENT, "Child:Segments");

	function _getNodeState(/*Node*/node) {
		return node && xml.enumGetText(node.State);
	}

	function isParentSiteLevel(/*Node*/parentNode) {
		return parentNode.$Type == "_CS_ApparelViews";
	}

	function _getState(/*Context*/ctx) {
		return _getNodeState(ctx.getNode());
	}

	function _getParentState(/*Context*/ctx) {
		return _getNodeState(ctx.getParent());
	}

	return {
		onAccessActionAddMCSalesMarkets: function(/*Context*/ctx, /*Action*/action) {
			return _getParentState(ctx) != NOT_AVAILABLE;
		},

		onAccessActionMakeMCUnavailable: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == REL_TO_CUST;
		},

		onAccessActionPushProductsToSalesCollection: function(/*Context*/ctx, /*Action*/action) {
			var state = _getParentState(ctx);
			return state == REL_TO_MARKET || state == REL_TO_CUST;
		},

		onAccessActionPushProductsToSalesLook: function(/*Context*/ctx, /*Action*/action) {
			var node = isParentSiteLevel(ctx.getParent()) ? ctx.getNode() : ctx.getParent();
			var state = _getNodeState(node);
			return (state == REL_TO_MARKET || state == REL_TO_CUST) && node.SalesLooks.length > 0;
		},

		onAccessActionReleaseMCProductToCustomers: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == REL_TO_MARKET && _getNodeState(ctx.getNodeParent(null, true)) == REL_TO_CUST;
		},

		onAccessActionReturnToDraftFromMarket: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == REL_TO_MARKET;
		},

		onAccessActionReturnCollectionToMarket: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == REL_TO_CUST;
		},

		onAccessActionReleaseMCProductToMarkets: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == DRAFT && (_getNodeState(ctx.getNodeParent(null, true)) == REL_TO_CUST || _getNodeState(ctx.getNodeParent(null, true)) == REL_TO_MARKET);
		},

		onAccessActionReleaseMCProductToMarketsSKU: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == DRAFT &&
			(_getNodeState(ctx.getNodeParent(null, true)) == REL_TO_CUST || _getNodeState(ctx.getNodeParent(null, true)) == REL_TO_MARKET) &&
			(_getNodeState(ctx.cache.getNode(ctx.getNode().Color)) == REL_TO_CUST || _getNodeState(ctx.cache.getNode(ctx.getNode().Color)) == REL_TO_MARKET) ;
		},

		onAccessActionReleaseMCToCustomers: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == REL_TO_MARKET;
		},

		onAccessActionReleaseMCToMarkets: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == DRAFT;
		},

		onAccessActionRemoveLookMCProduct: function(/*Context*/ctx, /*Action*/action) {
			return _getNodeState(ctx.getParent()) == DRAFT;
		},

		onAccessActionReturnMCToDraft: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == NOT_AVAILABLE;
		},

		onAccessActionReturnSMToDraft: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == NOT_AVAILABLE;
		},

		onAccessActionReturnAvailableSMToDraft: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == AVAILABLE;
		},

		onAccessActionSetSMAvailable: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == DRAFT;
		},

		onAccessActionSetSMUnavailable: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) != NOT_AVAILABLE;
		},

		onAccessActionSetSoldOut: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == AVAILABLE;
		},

		onAccessActionReturnSoldOutToAvailable: function(/*Context*/ctx, /*Action*/action) {
			return _getState(ctx) == SOLD_OUT;
		}
	};
});
